export const FOLLOW_UP_CHANNELS = [
  'whatsapp',
  'instagram',
  'facebook',
  'email',
  'phone',
] as const

export type FollowUpChannel = (typeof FOLLOW_UP_CHANNELS)[number]

export type FollowUpChannelActivity =
  | {
      activity_type?: string | null
      channel?: string | null
      type?: string | null
    }
  | null
  | undefined

export type FollowUpChannelProspect =
  | {
      preferred_channel?: string | null
      channel?: string | null
      contact_channel?: string | null
      whatsapp?: string | null
      phone?: string | null
      instagram?: string | null
      instagram_url?: string | null
      facebook?: string | null
      facebook_url?: string | null
      email?: string | null
    }
  | null
  | undefined

export type ResolveFollowUpChannelInput = {
  selectedChannel?: string | null
  lastActivity?: FollowUpChannelActivity
  recommendedChannel?: string | null
  prospect?: FollowUpChannelProspect
}

const CHANNEL_ALIASES: Record<string, FollowUpChannel> = {
  whatsapp: 'whatsapp',
  whatsapp_message: 'whatsapp',
  voice_note: 'whatsapp',
  instagram: 'instagram',
  instagram_message: 'instagram',
  facebook: 'facebook',
  facebook_message: 'facebook',
  email: 'email',
  phone: 'phone',
  phone_call: 'phone',
}

export function resolveFollowUpChannel({
  selectedChannel,
  lastActivity,
  recommendedChannel,
  prospect,
}: ResolveFollowUpChannelInput): FollowUpChannel | null {
  return (
    normalizeFollowUpChannel(selectedChannel) ??
    normalizeActivityChannel(lastActivity) ??
    normalizeFollowUpChannel(recommendedChannel) ??
    normalizeFollowUpChannel(prospect?.preferred_channel) ??
    normalizeFollowUpChannel(prospect?.channel) ??
    normalizeFollowUpChannel(prospect?.contact_channel) ??
    firstAvailableProspectChannel(prospect)
  )
}

export function normalizeFollowUpChannel(
  value: string | null | undefined,
): FollowUpChannel | null {
  if (!value) return null
  return CHANNEL_ALIASES[value.trim().toLowerCase()] ?? null
}

function normalizeActivityChannel(
  activity: FollowUpChannelActivity,
): FollowUpChannel | null {
  if (!activity) return null

  return (
    normalizeFollowUpChannel(activity.channel) ??
    normalizeFollowUpChannel(activity.activity_type) ??
    normalizeFollowUpChannel(activity.type)
  )
}

function firstAvailableProspectChannel(
  prospect: FollowUpChannelProspect,
): FollowUpChannel | null {
  if (!prospect) return null
  if (hasText(prospect.whatsapp)) return 'whatsapp'
  if (hasText(prospect.instagram) || hasText(prospect.instagram_url))
    return 'instagram'
  if (hasText(prospect.facebook) || hasText(prospect.facebook_url))
    return 'facebook'
  if (hasText(prospect.email)) return 'email'
  if (hasText(prospect.phone)) return 'phone'
  return null
}

function hasText(value: string | null | undefined): boolean {
  return Boolean(value?.trim())
}
